import { LoginFlow, RecoveryFlow, SettingsFlow } from '@ory/client';

export function getCSRFToken(response: RecoveryFlow | LoginFlow | SettingsFlow): string {
  const defaultNodes = response.ui.nodes.filter((node) => node.group === 'default');
  for (const node of defaultNodes) {
    if (node.attributes.node_type === 'input' && node.attributes.name === 'csrf_token') {
      return node.attributes.value;
    }
  }

  throw new Error('CSRF token not found in the response');
}
